

import { useParams } from "react-router-dom";
import { DisenioProducto, LayoutTabla } from "../../layout"
import { useStockProductoXId } from "../../../hooks";
import { AlertScreen, CargandoMedio } from "../../components";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";






export const ProductosStock = () => {

    
    const { id } = useParams();
    const { data, isLoading } = useStockProductoXId(id);


    return (
        <DisenioProducto titulo="Stock de Producto" url={1}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando stock de producto" />
            :   <>
                {(data.length > 0)
                ?   <LayoutTabla>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'35%'}}>Producto</TableCell>
                                <TableCell sx={{width:'35%'}}>Bodega</TableCell>
                                <TableCell sx={{width:'30%'}}>Cantidad</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map( (d) => (
                                <TableRow key={d.id}> 
                                    <TableCell>{ d.producto.nombre }</TableCell>
                                    <TableCell>{ d.bodega.nombre }</TableCell>
                                    <TableCell>{ d.stock }</TableCell>
                                </TableRow>
                            ))}

                            <TableRow>
                                <TableCell colSpan={2} sx={{ fontWeight:900, fontSize:17 }}>TOTAL</TableCell>
                                <TableCell style={{ fontWeight:900, fontSize:17 }}>
                                    {data.reduce((acc, d) => acc + d.stock, 0)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </LayoutTabla>

                : <AlertScreen title="No hay stock en bodegas." />
                }
                </>
            }
        </DisenioProducto>
    )
}
